import logo from "./chef6.gif";
import "./App.css";

function App() {
	return (
		<div className="App">
			<header className="App-header">
				<img src={logo} className="App-logo" alt="logo" />
				<p className="caption">俊哥蝦子麵</p>
			</header>
		</div>
	);
}

export default App;
